import { ErrorBoundary } from '../components/ErrorBoundary';
import AppRouter from './AppRouter.lazy';

export default function App() {
  return (
    <ErrorBoundary>
      <div className="h-full">
        <AppRouter />
      </div>
    </ErrorBoundary>
  );
}
